import React, { useState } from "react";
import styled, { css, keyframes } from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";

const TicketSelection = ({
  onSubtract,
  onAdd,
  ticket,
  vibration = false,
  isLww,
}) => {
  return (
    <TicketSelectionContainer
      key={Math.random()}
      vibration={vibration}
      bgcolor={ticket.bgColor}
    >
      <TicketSelectionDiv>
        <TicketCategory>{ticket.name}</TicketCategory>
        <Amount>
          {ticket.price} {Text.qar}
        </Amount>
      </TicketSelectionDiv>
      {isLww && (
        <TicketSelectionDiv style={{ width: "80%" }}>
          <DetailsText>{ticket?.specialInfo}</DetailsText>
        </TicketSelectionDiv>
      )}
      <TicketSelectionDiv>
        <NumberOfTickets>{Text.numberOfTickets}</NumberOfTickets>
        <ActionContainer>
          <CounterButton onClick={() => onSubtract(ticket._id)}>
            -
          </CounterButton>
          <CountValue>{ticket.count}</CountValue>
          <CounterButton onClick={() => onAdd(ticket._id)}>+</CounterButton>
        </ActionContainer>
      </TicketSelectionDiv>
    </TicketSelectionContainer>
  );
};

const TicketSelectionContainer = styled.div`
  width: 100%;
  flex-direction: column;
  display: flex;
  border-radius: 1rem;
  // background: #${(props) => props.bgcolor || "black"};
  background: #0a0f81;
  padding: 1rem;
  gap: 0.5rem;
  box-sizing: border-box;
  transition: transform 0.3s ease;

  ${(props) =>
    props.vibration === true
      ? css`
          animation: ${shakeAnimation} 0.1s ease;
          animation-duration: 0.5s;
          animation-iteration-count: 1;
        `
      : css``}
`;
const shakeAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  75% {
    transform: translateX(-5px);
  }
  100% {
    transform: translateX(0);
  }
`;
const TicketSelectionDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const TicketCategory = styled.div`
  color: ${Colors.approxSnow};
  font-size: 1rem;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  width: 70%;
`;

const Amount = styled.div`
  color: ${Colors.approxSnow};
  text-align: right;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  display: flex;
  flex-direction: column;
`;

const NumberOfTickets = styled.span`
  color: ${Colors.approxSnow};
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  opacity: 0.9;
`;

const ActionContainer = styled.div`
  width: 5rem;
  border-radius: 0.25rem;
  border: 1px solid ${Colors.white};
  display: flex;
  flex-direction: row;
`;

const CounterButton = styled.div`
  display: flex;
  color: ${Colors.white};
  justify-content: center;
  align-items: center;
  width: 33.33%;
  background: ${Colors.white};
  font-size: 1rem;
  background: transparent;
  border-radius: 0.25rem;
  cursor: pointer;
`;

const CountValue = styled(CounterButton)`
  color: ${Colors.approxCellow};
  background: ${Colors.white};
  border-radius: 0;
  cursor: default;
`;
const DetailsText = styled.span`
  color: ${Colors.white};
  font-size: 0.8rem;
  font-weight: 400;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export default TicketSelection;
